import * as yup from 'yup';

export type BuscadorEscriturasFormValues = {
	name: string;
	surname: string;
	notariaPoblacion: string;
	consuladoCiudad: string;
};

export const defaultValues: BuscadorEscriturasFormValues = {
	name: '',
	surname: '',
	notariaPoblacion: '',
	consuladoCiudad: '',
};

export const formSchema = yup.object({
	name: yup.string().trim().required('El nombre es obligatorio'),
	surname: yup.string().trim().required('El apellido es obligatorio'),
	notariaPoblacion: yup.string().trim().required('La población de la notaria es obligatoria'),
	consuladoCiudad: yup.string().trim().required('El consulado de la ciudad es obligatorio'),
});
